import { Link } from 'react-router-dom';
import { categories } from '@/mocks/comics';

export default function CategorySection() {
  return (
    <section className="py-12 md:py-16">
      <div className="max-w-[1400px] mx-auto px-4 md:px-6">
        {/* Header */}
        <div className="text-center mb-8">
          <h2 className="font-heading text-2xl md:text-3xl font-bold text-foreground-950">
            韩漫分类
          </h2>
          <p className="text-sm text-foreground-500 mt-1">
            按类型浏览你喜欢的韩国漫画
          </p>
        </div>

        {/* Category grid */}
        <div className="grid grid-cols-2 sm:grid-cols-3 md:grid-cols-4 lg:grid-cols-5 gap-3 md:gap-4">
          {categories.map((category) => (
            <Link
              key={category.slug}
              to={`/category/${category.slug}`}
              className="group flex items-center gap-3 p-4 rounded-xl bg-background-50 border border-background-200/70 hover:border-primary-200 hover:bg-primary-50/30 transition-all duration-200"
            >
              <div className="w-10 h-10 flex items-center justify-center rounded-lg bg-accent-100 text-accent-600 group-hover:bg-accent-200 group-hover:text-accent-700 transition-colors flex-shrink-0">
                <i className={`${category.icon} text-lg`} />
              </div>
              <div className="min-w-0">
                <p className="text-sm font-medium text-foreground-900 group-hover:text-primary-600 transition-colors">
                  {category.name}
                </p>
                <p className="text-xs text-foreground-400 mt-0.5">
                  {category.count} 部
                </p>
              </div>
            </Link>
          ))}
        </div>
      </div>
    </section>
  );
}